import React from 'react';
import { FaPhoneSquareAlt, FaEnvelope } from 'react-icons/fa';

import Registration from './Registration';
import RegistrationLeftSidePage from './RegistrationLeftSidePage';

import './Registration.css';

class RegistrationPage extends React.Component {
  render() {
    return (
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-8 regsidecol">
              <RegistrationLeftSidePage />
            </div>
            <div className="col-md-4 regcol">
              <div className="row">
                <div className="col-md-12 helpdiv">
                  <h6>Need assistance?</h6>
                  <h6 className="marginh6"><FaPhoneSquareAlt /> : <a href="+919136390992">+91 9136390992</a> </h6>
                  <h6> <FaEnvelope /> : <a href="mailto:sales@orggen.com">sales@orggen.com</a></h6> 
                </div>
              </div>
              <div className="formdivre">
                  <h2 className="pt-1 text-center">Registration</h2>
                  <hr className="hrr"></hr>
                  <form className="registration-form">
                    <Registration />
                  </form>
              </div>
              <div className="footertext text-center">
                <p>© 2021,
                  <a href="https://www.orggen.com/"> OrgGen Technologies</a>
                  All Rights Reserved.
                </p>
              </div>
            </div>                
          </div>
        </div>
      </section> 
    );
  }
}
export default RegistrationPage;
